import React from 'react'

/**
 * This div is the scroll container. Its padding is therefore part of the
 * scrollable area: content scrolls through it, above any `sticky top-0` child.
 * A panel that needs edge-to-edge sticky headers can opt out with
 * `className="!p-0"` and lay out its own padding. Omitted everywhere else,
 * so the default rendering is unchanged.
 */
const SlideOverBody = ({children, className = ''}) => {
    return (
        <div className={`relative p-4 md:p-6 flex-1 min-h-0 overflow-y-auto transition-opacity duration-200 ${className}`}>
            {children}
        </div>
    )
}

export default SlideOverBody
